/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_LoadingInputs */

const cs_page_title_loading = /** @type {(inputs: Page_Title_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítání…`)
};

const en_page_title_loading = /** @type {(inputs: Page_Title_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading…`)
};

/**
* | output |
* | --- |
* | "Loading…" |
*
* @param {Page_Title_LoadingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const page_title_loading = /** @type {((inputs?: Page_Title_LoadingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_LoadingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_page_title_loading(inputs)
	return cs_page_title_loading(inputs)
});